// TDS2 SHIM — composes plain elements; no direct TDS2 counterpart.
// Mirrors the prototype's CodeArtifactCard (UnitBuildAgent.tsx 788-826):
// a collapsible card that shows the first 3 lines of a code body with
// a "Show N lines / Show less" toggle to expand to a 10-line scroller.
import React from 'react';
import PropTypes from 'prop-types';

const COLLAPSED_LINES = 3;
const EXPANDED_LINES = 10;

function ChevronDownIcon({ expanded }) {
  const cls = 'tds2-agentforce-artifact__toggle-icon' +
    (expanded ? ' tds2-agentforce-artifact__toggle-icon--expanded' : '');

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cls}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

ChevronDownIcon.propTypes = {
  expanded: PropTypes.bool,
};

export default class CodeArtifactCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState((prev) => ({ expanded: !prev.expanded }));
  }

  render() {
    const { title, language, body } = this.props;
    const { expanded } = this.state;
    const text = body || '';
    const lines = text.split('\n');
    const hasOverflow = lines.length > COLLAPSED_LINES;
    const visibleBody = expanded || !hasOverflow
      ? text
      : lines.slice(0, COLLAPSED_LINES).join('\n');

    const wrapClass = 'tds2-agentforce-artifact' +
      (expanded ? ' tds2-agentforce-artifact--expanded' : '');

    const toggleLabel = expanded
      ? 'Show less'
      : 'Show ' + Math.min(lines.length, EXPANDED_LINES) + ' lines';

    return (
      <div className={wrapClass} data-tds2-shim="CodeArtifactCard">
        <div className="tds2-agentforce-artifact__header">
          <div className="tds2-agentforce-artifact__title">
            <span>{title}</span>
            {language ? (
              <span className="tds2-agentforce-artifact__language">{language}</span>
            ) : null}
          </div>
          {hasOverflow ? (
            <button
              type="button"
              className="tds2-agentforce-artifact__toggle"
              onClick={this.handleToggle}
              aria-expanded={expanded}
            >
              {toggleLabel}
              <ChevronDownIcon expanded={expanded} />
            </button>
          ) : null}
        </div>
        <pre className="tds2-agentforce-artifact__body" tabIndex={0}>{visibleBody}</pre>
        {!expanded && hasOverflow ? (
          <div className="tds2-agentforce-artifact__footer" aria-hidden="true">
            {lines.length - COLLAPSED_LINES} more lines
          </div>
        ) : null}
      </div>
    );
  }
}

CodeArtifactCard.propTypes = {
  title: PropTypes.string,
  language: PropTypes.string,
  body: PropTypes.string,
};

CodeArtifactCard.defaultProps = {
  title: 'Artifact',
};
